import { Injectable } from '@angular/core';
import {getCookie} from "../helpers/utils";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class RatingsPageService {
  private _apiPrefix = '/api/v1';
  private _ratingsListUrl = `${this._apiPrefix}/ratings/`;
  private _isStaff: boolean = false;
  private _acquiredRatingsList: SingleRatingData[] = [];
  private _dataTransformersSet: SingleRatingDataTransformers = {
    date_from: (dateString) => dateString.split('-').reverse().join('.'),
    title: (titleString) => titleString,
    detail_url: (value) => value,
    tournament_players_count: value => value,
    status_data: value => value.statusName,
    tournaments: value => value,
    game_data: gameData => gameData.gameName,

  };

  private _headers: string[] = [
    'Дата',
    'Название рейтинга',
    'Участников',
    'Статус рейтинга',
    'Турниров',
    'Вид игры',
  ];
  private _headersToKeys = {
    [this._headers[0]]: 'date_from' ,
    [this._headers[1]]: 'title',
    [this._headers[2]]: 'tournament_players_count',
    [this._headers[3]]: 'status_data',
    [this._headers[4]]: 'tournaments_count',
    [this._headers[5]]: 'game_data',
  };
  constructor(private http: HttpClient) { }

  private getCsrfToken(): string {
    return getCookie('csrftoken');
  };

  set isStaff(value: boolean) {
    this._isStaff = value;
  }

  get isStaff(): boolean {
    return this._isStaff;
  }

  getRatingsList() {
    return this.http.get(this._ratingsListUrl);
  }

  get acquiredRatingsList(): SingleRatingData[] {
    return this._acquiredRatingsList;
  }

  set acquiredRatingsList(list: SingleRatingData[]) {
    this._acquiredRatingsList = list;
  }

  get headers(): string[] {
    return this._headers;
  }

  get headersToKeysTranslator() {
    return this._headersToKeys;
  }

  get dataTransformersSet(): SingleRatingDataTransformers {
    return this._dataTransformersSet;
  }

}

interface StatusData {
  statusId: number,
  statusName: string,
}

interface GameData {
  gameId: number,
  gameName: string,
}

export interface SingleRatingData {
  date_from: string,
  title: string,
  detail_url: string,
  tournament_players_count: number,
  status_data: StatusData,
  tournaments: number,
  game_data: GameData,
  rating_id: number,
}

export interface SingleRatingDataTransformers {
  date_from: (dateString: string) => string,
  title: (titleString: string) => string,
  detail_url: (str: string) => string,
  tournament_players_count: (count: number) => number,
  status_data: (statusData: StatusData) => string,
  tournaments: (value: number) => number,
  game_data: (gameData: GameData) => string,
}
